"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _debounce = _interopRequireDefault(require("./debounce"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var EventSpy = function EventSpy(_ref) {
  var debounce = _ref.debounce,
      name = _ref.name,
      onEvent = _ref.onEvent,
      target = _ref.target; // We need to save the "onEvent" to ref.
  // This is because "onEvent" may change from time to time, but debounce may still fire to the older callback.

  var onEventRef = (0, _react.useRef)();
  onEventRef.current = onEvent;
  var debouncer = (0, _react.useMemo)(function () {
    return (0, _debounce.default)(function (event) {
      var current = onEventRef.current;
      current && current(event);
    }, debounce);
  }, [debounce, onEventRef]);
  var handleEvent = (0, _react.useCallback)(function (event) {
    event.timeStampLow = Date.now();
    debouncer(event);
  }, [debouncer]);
  (0, _react.useLayoutEffect)(function () {
    target.addEventListener(name, handleEvent, {
      passive: true
    });
    handleEvent({
      target: target,
      type: name
    });
    return function () {
      return target.removeEventListener(name, handleEvent);
    };
  }, [name, handleEvent, target]);
  return false;
};

EventSpy.defaultProps = {
  debounce: 200
};
var _default = EventSpy;
exports.default = _default;